import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { TaskAnalyticsKindEnum } from '@zaoblako/shared/modules/task/enum/task-analytics-kind.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link TaskAnalyticsKindEnum} enumeration values */
export const TaskAnalyticsKindEnumI18n: EnumI18nInterface<TaskAnalyticsKindEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [TaskAnalyticsKindEnum.BY_DIRECTION]: 'По БС',
    [TaskAnalyticsKindEnum.BY_DIRECTION_GROUP]: 'По группе БС',
  },
  [I18nLocalesEnum.EN_US]: {
    [TaskAnalyticsKindEnum.BY_DIRECTION]: 'By direction',
    [TaskAnalyticsKindEnum.BY_DIRECTION_GROUP]: 'By direction group',
  },
};
